import React from "react";

/**
 * Resolves an avatar URL — absolute HTTP URLs pass through, backend
 * `/api/...` paths get prefixed with REACT_APP_BACKEND_URL. Exported so
 * headers and menus can render the same avatar consistently.
 */
export function resolveAvatar(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return url.startsWith("/api") ? base + url : url;
}

/**
 * Circular avatar that falls back to initials on the household's stone
 * background. Used on the Profile page's identity section.
 */
export default function Avatar({ url, name, size = 96 }) {
  const initials = (name || "?").split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  const resolved = resolveAvatar(url);
  return (
    <div
      className="rounded-full overflow-hidden bg-hearth-stone grid place-items-center border border-hearth-line shadow-sm shrink-0"
      style={{ width: size, height: size }}
    >
      {resolved ? (
        <img src={resolved} alt={name || "avatar"} className="w-full h-full object-cover" />
      ) : (
        <span className="font-display text-hearth-clayDark" style={{ fontSize: Math.floor(size * 0.36) }}>{initials}</span>
      )}
    </div>
  );
}
